<template>
  <details class="simple" open>
    <summary>Gráfica de actividad</summary>
    <GChart type="BubbleChart" :data="chartData" :options="chartOptions" v-if="items.length" />
    <b-alert v-else variant="info" show> No hay datos suficientes para mostrar la gráfica. </b-alert>
  </details>
</template>
<script>
import { GChart } from "vue-google-charts/legacy";
import { makeBubbleOptions } from "./bubbleChartOptions.js";

function colorPorActividad(actividad) {
  if (actividad > 120) {
    return "> 120";
  } else if (actividad > 80) {
    return "> 80";
  } else {
    return "<= 80";
  }
}

export default {
  components: {
    GChart,
  },
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    chartData() {
      const table = [["Comercial", "Promedio Días Gestión", "Total ofertas", "Nivel actividad", "Ganadas"]];
      this.items.forEach((item) => {
        const color = colorPorActividad(item.totalOfertas);
        table.push([item.comercial, item.promedioDiasGestion, item.totalOfertas, color, item.ganadas]);
      });
      table.sort((a, b) => b[2] - a[2]);
      return table;
    },
  },
  data() {
    return {
      chartOptions: makeBubbleOptions({
        hAxis: { title: "Promedio Días Gestión (incluye todas)", minValue: 0, maxValue: 120 },
        vAxis: { title: "Total Ofertas", minValue: 0 },
        series: {
          "> 120": { color: "#2ecc71" },
          "> 80": { color: "#f1c40f" },
          "<= 80": { color: "#e74c3c" },
        },
      }),
    };
  },
};
</script>
